app.service('articlesSidebar', function(ajaxPage) {
	var $sidebar;

	function createURL(categories, types) {
		var link = $sidebar.find('[data-main-category]').data('main-category');
		if(categories.length) {
			link = $.makeArray(categories).join(',');
		}
		if(types.length) {
			link += ',typ-' + $.makeArray(types).join(',');
		}
		return link + '.bhtml';
	}

	function getActiveFields( name ) {
		return $sidebar.find('input[name="' + name + '"]:checked').map(function() { return this.id });
	}


	function changeLocation() {
		var categories = getActiveFields('categories');
		var types =  getActiveFields('types');
		var url = createURL(categories, types);

		window.location.href = '/artykuly/' + url;

		ajaxPage.load({
			url: url,
			beforeLoad: function(){
				$.scrollTo($('#breadcrumb'));
			}
		});

	}

	function setEvents() {
		$sidebar = $('.articles-sidebar');
		$sidebar.on('click', '.js-apply-filters', changeLocation);
	}

	function init() {
		setEvents();
	}

	return {
		init: init
	};
});
